import { formatDate } from '../format'
import { getDateFromString } from '../getDateFromString'
import isSameDay from 'date-fns/isSameDay'
import isSameMonth from 'date-fns/isSameMonth'
import isSameYear from 'date-fns/isSameYear'
import isBefore from 'date-fns/isBefore'
const localizedFormats = require('./translations.json')

export const transformer = (start, end) => {
  const now = new Date()
  const startDate = start && new Date(start)
  const endDate = end && new Date(end)

  return {
    hasEventExpired() {
      // case 1: event has an endDate and the endDate passed
      if (endDate && isBefore(endDate, now)) return true

      // case 2: event has no endDate, but is has started and didn't start today
      return !endDate && isBefore(startDate, now) && !isSameDay(startDate, now)
    },

    isSingleDayEvent() {
      return !endDate || isSameDay(startDate, endDate)
    },

    doesEventStartTheSameYearAsNow() {
      return isSameYear(startDate, now)
    },

    doesEventStartAndEndInTheSameMonth() {
      return !endDate || isSameMonth(startDate, endDate)
    },

    doesEventStartAndEndInTheSameYear() {
      return !endDate || isSameYear(startDate, endDate)
    },
  }
}

export const decideFormat = (start, end) => {
  const questions = transformer(start, end)
  if (questions.isSingleDayEvent()) {
    if (questions.hasEventExpired()) return 'START_YEAR'
    if (questions.doesEventStartTheSameYearAsNow()) return 'START_MONTH'

    return 'START_YEAR'
  }

  if (questions.doesEventStartAndEndInTheSameMonth()) {
    if (questions.hasEventExpired()) return 'START_MONTH_END_YEAR'

    return 'START_MONTH_END_DAY'
  }

  if (questions.doesEventStartAndEndInTheSameYear()) {
    if (questions.doesEventStartTheSameYearAsNow()) return 'START_MONTH_END_MONTH'

    return 'START_MONTH_END_MONTH_YEAR'
  }

  return 'START_YEAR_END_YEAR'
}

export const applyFormat = (eventDateFormat, start, end, language) => {
  const languageFormats = localizedFormats[language] || localizedFormats.en

  const { start: startFormat, end: endFormat } = languageFormats[eventDateFormat]

  let { template } = languageFormats[eventDateFormat]

  if (start && startFormat) {
    const startDate = getDateFromString(start)
    template = template.replace('{start}', formatDate(startDate, startFormat, language))
  }

  if (end && endFormat) {
    const endDate = getDateFromString(end)
    template = template.replace('{end}', formatDate(endDate, endFormat, language))
  }

  return template
}

export const createEventDateFormatter = language => (start, end) => {
  const eventDateFormat = decideFormat(start, end)
  return applyFormat(eventDateFormat, start, end, language)
}
